import CardNumberInfo from './CardNumberInfo'

export default CardNumberInfo
